import { pick } from 'lodash'

const syncTypeMap = {
  1: '電話予約',
  2: 'ネット予約',
  3: 'ウォークイン',
  4: 'ぐるなび予約',
  5: 'ぐるなび予約（法人）',
  6: 'ぐるなび予約（外国）',
  7: '電話自動受付',
  8: 'POS+',
  9: '食べログ',
  10: 'ホットペッパー',
  11: 'クラブミシュラン',
  12: '連携解除予約',
  13: '一休',
  14: 'OZmall',
  15: 'オリジナル予約',
  16: 'Retty',
  17: 'カメラ着席',
  18: 'セールスフォース',
  19: 'NEC POS',
  20: 'カメラ連携',
  21: 'J-Dining',
  22: 'ヒトサラ',
  23: 'ベネフィット・ワン',
  24: 'PayPayグルメ',
  100: 'ブロック',
}

export default syncTypeMap

// 本アプリからも設定可能な予約方法
export const syncFromGnaviDaicho = pick(syncTypeMap, [1, 2, 3])

// ぐるなび予約連携
export const syncFromGnavi = pick(syncTypeMap, [4, 5, 6, 11, 18])
export const isGnavi = syncType => !!syncFromGnavi[syncType]

// ぐるなび相互連携
export const isInteractiveSyncType = syncType => [4, 11].includes(syncType)

// IVR予約
export const syncFromIVR = pick(syncTypeMap, [7])
export const isIVR = syncType => !!syncFromIVR[syncType]

// POS連携
export const syncFromPOS = pick(syncTypeMap, [8])

// 他社取込
export const syncFromOtherCompany = pick(syncTypeMap, [9, 10, 13, 14, 16, 24])

// オリジナル予約
export const isDaicho = syncType => syncType === 15

// ウォークイン
export const syncFromWalkin = syncType => [3, 8, 17].includes(syncType)

// レスラク
export const syncFromResraku = pick(syncTypeMap, [21, 22, 23])
export const isResraku = syncType => !!syncFromResraku[syncType]

// ブロック予約
export const isBlockSyncType = syncType => syncType === 100
